module.exports = __webpack_public_path__ + "img/xp-tb-games.f0349c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-games.png
// module id = FlFe
// module chunks = 39 44